import Skeleton from 'react-loading-skeleton';
import clsx from 'clsx';

import { VolumeType } from './VolumeGrid';

export default function VolumeCardSkeleton({ volumeType }: { volumeType?: VolumeType }) {
  return (
    <div className="flex flex-col gap-2 p-5 h-fit overflow-y-auto border-gray-300 border rounded-lg">
      {/* Header with volume ID and action buttons */}
      <div className="flex justify-between items-center">
        <SkeletonLoader w={140} h={24} />
        {/* <div className="flex gap-1">
          <SkeletonLoader w={28} h={28} />
          <SkeletonLoader w={28} h={28} />
        </div> */}
      </div>

      {/* Instance tag area */}
      <div className="min-h-[28px] flex items-center">
        <SkeletonLoader w={100} h={24} />
      </div>

      {/* Stats section */}
      <div className="flex flex-col gap-1.5">
        <div className="flex divide-x-2 gap-2 py-1 divide-gray-300">
          <div className="flex gap-1 items-center pr-3">
            <SkeletonLoader w={70} h={16} />
          </div>
          <SkeletonLoader w={80} h={16} className="mr-3" />
          <SkeletonLoader w={60} h={16} />
        </div>
      </div>

      {volumeType === 'exception' && (
        <div className="flex items-center">
          <div className="flex items-center flex-1">
            <SkeletonLoader w={20} h={20} className="mr-1" />
            <SkeletonLoader w={90} h={16} />
          </div>
          <SkeletonLoader w={120} h={36} />
        </div>
      )}
    </div>
  );
}

function SkeletonLoader({ w, h, className }: { w: number; h: number; className?: string }) {
  return (
    <Skeleton
      width={w}
      height={h}
      baseColor="var(--color-gray-200)"
      highlightColor="#fff"
      className={clsx('rounded-md leading-[unset!important] ', className)}
    />
  );
}
